import { IUser } from 'models';
import { useContext } from 'react';
import { SignedInUserContext } from 'utils/context';

export function useUser() : IUser {
  const user = useContext(SignedInUserContext);

  return user;
}
